module.exports = __webpack_public_path__ + "static/img/adoption_movie_thum_01.f4473c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/movie/adoption_movie_thum_01.jpg
// module id = 1u/a
// module chunks = 0